import React, { Component } from "react";
import styles from "./ToggleTypesBox.scss";
import ToggleTypes from "./ToggleTypes";
import { connect } from "react-redux";
import { setToggleTypes } from "../../../../actions/Map/mapActions";

const showTypeBox = [
  "SCHOOLS", // done
  "HEALTHCARE", // done
  // "WORSHIP", // NEEDS TO BE UNCOMMENTED IN MAPBOX TOO
  // "RESTAURANTS", // NEEDS TO BE UNCOMMENTED IN MAPBOX TOO
  "SPORTS", // done
  "HOUSES",  // done
  "ENTERTAINMENT", // done
  "TRANSIT", // done
];


class ToggleTypesBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
          toggledCategories: [],
          extendedCategory: undefined,
        };
    }

    componentDidMount = () => {
      this.props.setToggleTypes(Object.keys(this.props.types));
      this.getLatestCategories();
    }

    componentDidUpdate = (prevProps) => {
      if (prevProps.toggleMarkers !== this.props.toggleMarkers) {
        this.getLatestCategories();
      }
    }

    extendCategory = (_category) => {
      if (_category === this.state.extendedCategory){
        this.setState({
          extendedCategory: undefined
        })
      }
      else {
        this.setState({
          extendedCategory: _category
        })
      }
    }

    getLatestCategories = () => {
      const toggleArray =
        // Turn from object, to key value array
        Object.entries(this.props.toggleMarkers)
        // Get only toggled markers
        .filter((pair) => pair[1])
        // Get only name, remove boolean
        .map((pair) => pair[0].toUpperCase());

      this.setState({ toggledCategories: toggleArray })
    }



    render() {
        if (this.state.toggledCategories.length === 0){
          return (<div></div>)
        }
        else {
          return (
            <div className={styles.ToggleTypeBox}>
              {this.state.toggledCategories.map((category) => {
                if (showTypeBox.includes(category)){
                  return (
                    <ToggleTypes
                      key={category}
                      types={this.props.types[category]}
                      category={category}
                      extendCategory={this.extendCategory}
                      extendedCategory={this.state.extendedCategory}
                      getMarkers={this.props.getMarkers}
                    />
                  )
                }
                else { return (<div></div>)}
              })}
            </div>
          )
        }
    }
}

function mapStateToProps(state) {
  return { };
}

const actions = {
  setToggleTypes
};

export default connect(
  mapStateToProps,
  actions
)(ToggleTypesBox);



// WEBPACK FOOTER //
// ./src/components/pages/Map/ToggleTypes/ToggleTypesBox.js